import React, { useState } from 'react';
import SurveyPanel from "../components/SurveyPanel";
import IntroPanel from "../components/IntroPanel";
import InputPanel from "../components/InputPanel";
import { introPanelTexts } from "../../constants/textContent.js";

const PreSession = ({ setActivePanel, startChat, setHashedInput, setUserId }) => {
    const [stage, setStage] = useState('intro');
    const [localUserId, setLocalUserId] = useState('');

    const handleContinueToInput = () => {
        setStage('input');
    };

    const handleContinueToSurvey = () => {
        setStage('survey');
    };

    const handleContinueToPostSurvey = () => {
        setStage('postSurvey');
    };

    const handleStartChat = () => {
        startChat();
        setActivePanel('Current Session');
    };

    return (
        <>
            {stage === 'intro' && (
                <IntroPanel
                    onContinue={handleContinueToInput}
                    onStartChat={null}
                    showStartButton={false}
                    updatedText={null}
                />
            )}
            {stage === 'input' && (
                <InputPanel
                    onContinue={(rawUserId) => {
                        setUserId(rawUserId);
                       // handleContinueToSurvey();
			handleContinueToPostSurvey();	
		    }}
                    setHashedInput={setHashedInput}
                />
            )}
            {stage === 'survey' && (
                <SurveyPanel onContinueToCurrentSession={handleContinueToPostSurvey} />
            )}
            {stage === 'postSurvey' && (
                <IntroPanel
                    onContinue={null}
                    onStartChat={handleStartChat}
                    showStartButton={true}
                    updatedText={introPanelTexts.nextStageDescription}
                />
            )}
        </>
    );
};

export default PreSession;
